import Label from "../../core/components/Label";

export default function ColoredLabel(props: any) {
  if (props.processingPhase === "Summarizing") {
    return <Label color="primary">Özetleniyor</Label>;
  }

  switch (props.status) {
    case "TRANSCRIPTED":
      return <Label color="success">Oluşturuldu</Label>;
    case "TRANSCRIBING":
      return <Label color="primary">Oluşturuluyor</Label>;
    case "DELETED":
      return <Label color="error">Silindi</Label>;
    case "CANCELED":
      return <Label color="warning">İptal Edildi</Label>;
    case "FAILED":
      return <Label color="error">Oluşturulmadı</Label>;
    default:
      return <Label color="error">Oluşturulmadı</Label>;
  }
}
